<script>
	import { customCss, useCustomCss } from '../share/stores';
	import { onMount } from 'svelte';
	import ToggleButton from './content/ToggleButton.svelte';
	
	export let buttonText = 'Kunden-Farbwelt';
	export let clickEvent = () => {};
	
	let toggleColor = '';
	let toggleBackgroundColor = '';

	function setToggleColors() {
		const tempCssDiv = document.createElement('div');
		tempCssDiv.style = $customCss;
		//toggle body class:
		$useCustomCss ?
				document.body.classList.add('useCustomCss') :
				document.body.classList.remove('useCustomCss');
			toggleColor = tempCssDiv.style.getPropertyValue('--custom-background-color');
		// invert default colors, otherwise toggle will be black on black
		if (toggleColor === 'white') {
			toggleColor = 'black';
			toggleBackgroundColor = 'white';
		}
	}
	
	onMount(() => {
		setToggleColors();
	})

	$:updateToggleColors = ($useCustomCss || $customCss) && setToggleColors();
</script>

<div
	class="custom_css"
	class:custom_css--active={$useCustomCss}
	on:click={() => clickEvent()}
>
	{buttonText}
	<ToggleButton {toggleColor} {toggleBackgroundColor}/>
</div>

<style lang="scss">
	@import "../style/mixins";
	@import "../style/variables";
	
	.custom_css {
		--button-height: 2.5rem;
		--toggle-distance: 2px;
		z-index: 5;
		font-size: 1.4rem;
		color: #FFF;
		display: grid;
		grid-template-columns: auto auto;
		gap: 20px;
		align-items: center;
		width: fit-content;
		margin-right: 0;
		position: relative;
		left: 100%;
		transform: translateX(-100%);

		@include for-phone-only {
			grid-column-start: 3;
		}

		@include for-tablet-landscape-up {
			margin-right: px-to-rem(142);
		}
	}
</style>
